module.exports = __webpack_public_path__ + "static/media/win.04da9b4e.jpeg";